// represents the haste-application
var haste = function(appName, options) {
  this.appName = appName;
  this.config = {baseURL: defaultURL(), baseTitle: this.appName, 
                 ...options};
  this.ui = new HasteUI(this.config);
  this.view = {
    set: function(val, mode) { this.val = val; },
    get: function() { return this.val || ''; }
  };
};

const isHTTP = typeof window !== 'undefined' && window.location.protocol.match(/^https?:/);

function defaultURL() {
  return isHTTP ? '' : 'http://localhost:7777';
}

class HasteUI {
  constructor(config) {
    this.config = config;
  }

  enterDocument(key) {
    if (key !== this._key) {
      this.setTitle(key);
      if (isHTTP)
        window.history.pushState(null, this.mkTitle(key), this.mkURL(key));
    }
    this._key = key;
  }
  
  setTitle(ext) {
    document.title = this.mkTitle(ext);	
  }

  mkURL(key) {
    return `${this.config.baseURL}/${key || ''}`;
  }

  mkTitle(ext) {
    return ext ? `${this.config.baseTitle} - ${ext}` : this.config.baseTitle;
  }

  configureButtons(container, actions) {
    this.buttons = [
      {
        $where: container.find('.save'),
        label: 'Save',
        shortcutDescription: 'control + s',
        shortcut: function(evt) {
          return evt.ctrlKey && evt.keyCode === 83;
        },
        action: actions.save
      },
      {
        $where: container.find('.new'),
        label: 'New',
        shortcutDescription: 'control + n',
        shortcut: function(evt) {
          return evt.ctrlKey && evt.keyCode === 32;
        },
        action: actions.new
      },
      {
        $where: container.find('.duplicate'),
        label: 'Duplicate & Edit',
        shortcutDescription: 'control + d',
        shortcut: function(evt) {
          return /*_this.doc.locked &&*/ evt.ctrlKey && evt.keyCode === 68;
        },
        action: actions.duplicate
      },
      {
        $where: container.find('.raw'),
        label: 'Just Text',
        shortcutDescription: 'control + shift + r',
        shortcut: function(evt) {
          return evt.ctrlKey && evt.shiftKey && evt.keyCode === 82;
        },
        action: actions.raw
      },
      {
        $where: container.find('.twitter'),
        label: 'Twitter',
        shortcutDescription: 'control + shift + t',
        shortcut: function(evt) {
            return /*_this.options.twitter && _this.doc.locked &&*/ evt.shiftKey && evt.ctrlKey && evt.keyCode == 84;
        },
        action: function() {
          window.open('https://twitter.com/share?url=' + encodeURI(window.location.href));
        }				
      }
    ];
    this.tooltip = new Tooltip(container);
    for (var i = 0; i < this.buttons.length; i++) {
      this.configureButton(this.buttons[i]);
    }
  }

  configureButton(options) {
    options.$where.click(function(evt) {
      evt.preventDefault();
      if (!options.clickDisabled && $(this).hasClass('enabled')) {
        options.action();
      }
    });
    this.tooltip.attach(options.$where, options);
  }

  /** registers the configured shortcuts */
  configureShortcuts() {
    var _this = this;
    $(document.body).on('keydown', function(evt) {
      var button;
      for (var i = 0; i < _this.buttons.length; i++) {
        button = _this.buttons[i];
        if (button.shortcut && button.shortcut(evt)) {
          evt.preventDefault();
          button.action();
          return;
        }
      }
    });
  }

  /** show the light key */
  lightKey() { this.configureKey(['new', 'save']); }

  /** show the full key */
  fullKey() { this.configureKey(['new', 'duplicate', 'twitter', 'raw']); }

  /** show ongoing operation in key */
  progressKey(o) {
    this.configureKey([]);
    this.configureKey(o, 'ongoing');
  }

  /** set the enabled buttons */
  configureKey(enable, className='enabled') {
    for (let [k, v] of Object.entries(this.buttons || {})) {
      v.$where.toggleClass(className, k in enable);
    }
  }

  /**
   * Embeds the toolbar in an existing document.
   */
  embed(container = document.body) {
    return $('<div>').addClass('hastebin--embedded').html(`
		  <div id="pointer" style="display:none;"></div>
			<div id="box1"> <a href="/about.md" class="logo"></a> </div>
			<div id="box2"> <button class="save function button-picture">Save</button>
				              <button class="new function button-picture">New</button>
				              <button class="duplicate function button-picture">Duplicate & Edit</button>
				              <button class="raw function button-picture">Just Text</button>
				              <button class="twitter function button-picture">Twitter</button> </div>
			<div id="box3" style="display:none;"> <div class="label"></div> <div class="shortcut"></div> </div>`)
    .appendTo(container || $(document.body));
  }
}

class Tooltip {
  constructor(container) {
    this.$box = container.find('#box3');
    this.$arrow = container.find('#pointer');
  }

  attach($button, action) {
    var _this = this;
    // Show the label
    $button.mouseenter(function() {
      _this.show($(this), action);
    });
    // Hide the label
    $button.mouseleave(function() {
      _this.hide();
    });
  }

  show($button, action) {
    this.$box.find('.label').text(action.label);
    this.$box.find('.shortcut').text(action.shortcutDescription || '');
    this.$box.show();
    $button.append(this.$arrow.remove().show());
  }

  hide() {
    this.$box.hide();
    this.$arrow.hide();
  }
}


// setup a new, blank document
haste.prototype.newDocument = function() {
  this.doc = new haste_document(this.config);
  this.ui.enterDocument(undefined);
  this.ui.lightKey();
  this.view.set('', 'w', this.doc);
};

// load an existing document
haste.prototype.loadDocument = function(key) {
  var _this = this;
  _this.doc = new haste_document(this.config);
  _this.doc.load(key, function(ret) {
    if (ret) {
      _this.enterDocument(ret);
    } else {
      _this.newDocument();
    }
  });
};

// saves the current document (without locking it)
haste.prototype.saveDocument = function(cb) {
  this.doc.save(this.view.get(), cb);
};

// duplicate the current document
haste.prototype.duplicateDocument = function() {
  if (this.doc.locked) {
    var currentData = this.doc.data;
    this.newDocument();
    this.view.set(currentData, 'w');
  }
};

// save and lock the current document
haste.prototype.lockDocument = function(cb) {
  var _this = this;
  this.ui.progressKey(['save']);
  this.doc.save(this.view.get(), function(err, ret) {
    _this.ui.progressKey([]);
    if (err) {
      _this.showMessage(err.message, 'error');
    }
    else if (ret) {
      _this.enterDocument(ret);
    }
    if (cb) cb(err, ret);
  });
};

haste.prototype.enterDocument = function(doc) {
  /** @todo language and stuff */
  this.ui.enterDocument(doc.key);
  this.ui.fullKey();
  this.view.set(doc.value, 'r', doc);
};

// just unlock the document, without updating the view
haste.prototype.unlockDocument = function(cb) {
  this.doc.locked = false;
  this.ui.enterDocument(undefined);
  this.ui.lightKey();
  if (cb) cb();
}

// Low-level api to manipulate documents
haste.prototype.getDocument = function(key, cb) {
  var doc = new haste_document(this.config);
  cb = cb || function() { };
  if (key) {
    doc.load(key, function(ret) { ret ? cb(doc) : cb(ret); });
  }
  else {
    cb(doc);
  }
  return doc;
};

// configure buttons and their shortcuts
haste.prototype.configureButtons = function(container) {
  var _this = this;
  container = container || $('#key');
  this.ui.configureButtons(container, {
    save: function() {
      if (!_this.view.get().match(/^\s+$/)) {
        _this.lockDocument();
      }
    },
    new: function() {
      _this.newDocument(!_this.doc.key);
    },
    duplicate: function() {
      _this.duplicateDocument();
    },
    raw: function() {
      window.location.href = '/raw/' + _this.doc.key;
    },
    twitter: function() {
      window.open('https://twitter.com/share?url=' + encodeURI(window.location.href));
    }
  });
};


// enables the configured shortcuts
haste.prototype.configureShortcuts = function() {
  this.ui.configureShortcuts();
};

// embed the UI in the current document
haste.prototype.embed = function(container) {
  this.configureButtons(this.ui.embed(container));
}

// represents a single document
var haste_document = function(config) {
  this.config = config;
  this.locked = false;
};

haste_document.prototype.format = function(data) {
  /** @todo highlight/escape */
  return {value: data};
};

// load a document from the server
haste_document.prototype.load = function(key, callback) {
  var _this = this;
  $.ajax(this.config.baseURL + '/documents/' + key, {
    type: 'get',
    dataType: 'json',
    success: function(res) {
      _this.locked = true;
      _this.key = key;
      _this.data = res.data;
      var value = _this.format(res.data),
          lineCount = res.data.split('\n').length;
      callback({key: key, lineCount, ...value});
    },
    error: function(err) {
      callback(false);
    }
  });
};

// sends the document to the server
haste_document.prototype.save = function(data, callback) {
  if (this.locked) {
    return false;
  }

  this.data = data;
  var _this = this;
  $.ajax(this.config.baseURL + '/documents', {
    type: 'post',
    data: this.config.trim ? data.trim() : data,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function(res) {
      _this.locked = true;
      _this.key = res.key;
      var value = _this.format(data),
          lineCount = data.split('\n').length;
      callback(null, {key: res.key, lineCount, ...value});
    },
    error: function(res) {
      try {
        callback($.parseJSON(res.responseText));
      }
      catch (e) {
        callback({message: 'Something went wrong!', error: e});
      }
    }
  });
};


import hljs from 'highlight.js/lib/core';

class HtmlCodeFormat {
  format(data, lang) {
    try {
      if (lang === 'txt') {
        return { value: this.htmlEscape(data) };
      }
      else if (lang) {
        return hljs.highlight(lang, data);
      }
      else {
        return hljs.highlightAuto(data);
      }
    } catch(err) {
      // failed highlight, fall back on auto
      return hljs.highlightAuto(data);
    }
  }

  htmlEscape(s) {
    return s
      .replace(/&/g, '&amp;')
      .replace(/>/g, '&gt;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }  
}


export { haste, haste_document, HasteUI, HtmlCodeFormat }
